import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { usePlaceThumbnail } from '@/components/Messages/MessagePlaces';

export default function MapPlaceCard({ place, index, width, palette, onPress }) {
  const thumbnail = usePlaceThumbnail(place);
  return (
    <Pressable accessibilityRole="button" accessibilityLabel={`About ${place.title}`}
      onPress={() => onPress(place)}
      style={({ hovered, pressed }) => [styles.card, { width, backgroundColor: palette.preview, opacity: pressed ? 0.85 : 1, transform: [{ scale: hovered ? 1.015 : 1 }] }]}>
      <View style={styles.fallback}><Icon name="location-dot" size={44} color={palette.icon} /></View>
      {thumbnail.uri && <Image source={{ uri: thumbnail.uri }} style={StyleSheet.absoluteFillObject} contentFit="cover" onError={thumbnail.onError} />}
      <LinearGradient colors={['transparent', 'rgba(0,0,0,0.9)']} style={StyleSheet.absoluteFillObject} />
      <View style={styles.badge}><Text size="xs" weight="semibold" style={styles.white}>{index + 1}</Text></View>
      <View style={styles.details}>
        {(typeof place.rating === 'number' || place.type) && <View style={styles.meta}>
          {typeof place.rating === 'number' && <>
            <Icon name="star" size={12} color="#fff" solid />
            <Text size="s" weight="semibold" style={styles.white}>{place.rating.toFixed(1)}</Text>
          </>}
          {!!place.type && <Text size="xs" numberOfLines={1} style={styles.type}>{place.type}</Text>}
        </View>}
        <Text weight="semibold" numberOfLines={2} style={styles.title}>{place.title}</Text>
        {!!place.address && <Text size="xs" numberOfLines={2} style={styles.secondary}>{place.address}</Text>}
        {!!place.openState && <Text size="xs" numberOfLines={1} style={styles.secondary}>{place.openState}</Text>}
        {!!place.memoryReason && <View style={styles.reason}><Icon name="sparkles" size={12} color="#fff" /><Text size="xs" numberOfLines={3} style={[styles.secondary, { flex: 1 }]}>{place.memoryReason}</Text></View>}
      </View>
      <View style={styles.arrow}><Icon name="arrow-right" size={15} color="#fff" /></View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: { height: 320, borderRadius: 22, overflow: 'hidden', justifyContent: 'flex-end' },
  fallback: { ...StyleSheet.absoluteFillObject, alignItems: 'center', justifyContent: 'center' },
  badge: { position: 'absolute', top: 16, left: 16, width: 28, height: 28, borderRadius: 14, backgroundColor: 'rgba(0,0,0,0.65)', alignItems: 'center', justifyContent: 'center' },
  details: { padding: 22, paddingRight: 42, gap: 7 },
  meta: { flexDirection: 'row', alignItems: 'center', gap: 6 },
  white: { color: '#fff' },
  type: { color: '#eee', flexShrink: 1 },
  title: { color: '#fff', fontSize: 22, lineHeight: 27, letterSpacing: -0.5 },
  secondary: { color: '#eee', lineHeight: 17 },
  reason: { flexDirection: 'row', gap: 6, alignItems: 'flex-start', marginTop: 5 },
  arrow: { position: 'absolute', right: 18, bottom: 26 },
});
